import { render, staticRenderFns } from "./htmlformat.vue?vue&type=template&id=9aff08d4&"
import script from "./htmlformat.vue?vue&type=script&lang=js&"
export * from "./htmlformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports